import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../baseQuery';
import type { MonitoringSlot, SlotMessage } from './masterAdminMonitoringApi';

export const schoolAdminMonitoringApi = createApi({
	reducerPath: 'schoolAdminMonitoringApi',
	baseQuery: axiosBaseQuery,
	tagTypes: ['SaMonToday', 'SaMonWeek', 'SaMonAction', 'SaSlotMessages'],
	endpoints: (builder) => ({
		saGetMonToday: builder.query<
			{
				dayBucket: string;
				timezone: string;
				slots: MonitoringSlot[];
				counts: Record<string, number>;
			},
			void
		>({
			query: () => ({ url: '/school-admin/monitoring/today' }),
			providesTags: ['SaMonToday'],
		}),
		saGetMonWeek: builder.query<
			{
				weekStartDate?: string;
				startDate?: string;
				endDate?: string;
				timezone: string;
				slots: MonitoringSlot[];
			},
			{ weekStartDate?: string; startDate?: string; endDate?: string }
		>({
			query: ({ weekStartDate, startDate, endDate }) => ({
				url: '/school-admin/monitoring/week',
				params: { weekStartDate, startDate, endDate },
			}),
			providesTags: ['SaMonWeek'],
		}),
		saGetMonActionRequired: builder.query<{ items: MonitoringSlot[] }, void>({
			query: () => ({ url: '/school-admin/monitoring/action-required' }),
			providesTags: ['SaMonAction'],
		}),
		saReviewMissed: builder.mutation<
			any,
			{ slotId: string; decision: 'accepted' | 'rejected'; adminNote?: string }
		>({
			query: ({ slotId, ...body }) => ({
				url: `/school-admin/monitoring/slots/${slotId}/review`,
				method: 'POST',
				data: body,
			}),
			invalidatesTags: ['SaMonAction', 'SaMonToday', 'SaMonWeek'],
		}),
		saListSlotMessages: builder.query<{ messages: SlotMessage[] }, string>({
			query: (slotId) => ({
				url: `/school-admin/monitoring/slots/${slotId}/messages`,
			}),
			providesTags: (_r, _e, slotId) => [{ type: 'SaSlotMessages', id: slotId }],
		}),
		saPostSlotMessage: builder.mutation<any, { slotId: string; body: string }>({
			query: ({ slotId, body }) => ({
				url: `/school-admin/monitoring/slots/${slotId}/messages`,
				method: 'POST',
				data: { body },
			}),
			invalidatesTags: (_r, _e, { slotId }) => [
				{ type: 'SaSlotMessages', id: slotId },
			],
		}),
	}),
});

export const {
	useSaGetMonTodayQuery,
	useSaGetMonWeekQuery,
	useSaGetMonActionRequiredQuery,
	useSaReviewMissedMutation,
	useSaListSlotMessagesQuery,
	useSaPostSlotMessageMutation,
} = schoolAdminMonitoringApi;
